import React, {memo, useMemo} from 'react'

import {WORKING_DIRECTORY} from '../JobStep.consts'
import {JobStepProperty} from '../JobStepProperty/JobStepProperty'
import ShowAllOptions from '../ShowAllOptions/ShowAllOptions'

import type {HotProperty} from './JobStepHotFields.descriptors'
import {generatedFields} from './JobStepHotFields.descriptors'
import type {JobStepHotFieldsProps} from './JobStepHotFields.types'

const workingDirectory: HotProperty = {
  name: WORKING_DIRECTORY,
  label: 'Working directory',
  placeholder: 'repository root',
}

function JobStepHotFields({showOnlyMain, showOnlyAdvanced, ...otherProps}: JobStepHotFieldsProps) {
  const {step, autoFocus} = otherProps
  const {type} = step

  const hotProperties: ReadonlyArray<HotProperty> | null = useMemo(
    () => [workingDirectory, ...(generatedFields[type] ?? [])],
    [type],
  )
  const advancedProperties = useMemo(
    () => hotProperties?.filter(prop => prop.advanced) ?? [],
    [hotProperties],
  )

  if (hotProperties == null) {
    return null
  }

  return (
    <React.Fragment>
      {!showOnlyAdvanced &&
        hotProperties.map((hotProperty, index) => (
          <JobStepProperty
            key={hotProperty.name}
            {...otherProps}
            {...hotProperty}
            autoFocus={hotProperty.autoFocus || (autoFocus && index === 0)}
          />
        ))}
      {!showOnlyMain && advancedProperties.length > 0 && (
        <ShowAllOptions>
          {advancedProperties.map(hotProperty => (
            <JobStepProperty key={hotProperty.name} {...otherProps} {...hotProperty} withAdvanced />
          ))}
        </ShowAllOptions>
      )}
    </React.Fragment>
  )
}

export default memo<JobStepHotFieldsProps>(JobStepHotFields)
